import { faChevronLeft, faChevronRight } from "@fullscript/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";

import { IconButton, type IconButtonProps } from "@aviary/components/Button/IconButton";
import { l } from "@aviary/locales/i18n";
import { FontAwesomeIcon } from "@shared/react-fontawesome/react-fontawesome";

import * as styles from "./ArrowButton.styles";

interface Props extends Omit<IconButtonProps, "aria-label"> {
  type: "previous" | "next";
  /*
   * Whether or not the button is focused
   * @default false
   */
  isFocused: boolean;
  /**
   * If true, the control stays visible without hovering the carousel wrapper (e.g. full-screen image modal).
   * @default false
   */
  persistentVisible?: boolean;
}

const ArrowButton = ({ type, isFocused = false, persistentVisible = false, ...rest }: Props) => {
  const { t } = useTranslation();
  const isPrevious = type === "previous";

  const baseButton = persistentVisible ? styles.buttonPersistent : styles.button;
  const buttonStyles = [
    baseButton,
    styles.positioning.base,
    styles.positioning[type],
    ...(persistentVisible ? [] : [styles.focused(isFocused)]),
  ];

  const renderAriaLabel = isPrevious ? l.aviary.carousel.previous : l.aviary.carousel.next;

  const renderIcon = isPrevious ? faChevronLeft : faChevronRight;

  return (
    <IconButton aria-label={t(renderAriaLabel)} isCircular css={buttonStyles} {...rest}>
      <FontAwesomeIcon icon={renderIcon} />
    </IconButton>
  );
};

ArrowButton.displayName = "NewCarousel.ArrowButton";

export { ArrowButton };
